import type { OrderSummary } from '@cult/schemas';
import { Card, Divider, Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import { formatPoints } from '../../utils';
import { OrderStatusTag } from '../OrderStatusTag/OrderStatusTag';
import styles from './PurchaseCard.module.scss';

const { Text, Title } = Typography;

type Props = {
  purchase: OrderSummary;
};

export const PurchaseCard = ({ purchase }: Props) => (
  <Card className={styles.card} styles={{ body: { padding: 20 } }}>
    <Flex justify="space-between" align="center" gap={12} wrap>
      <Flex align="center" gap={10} wrap>
        <Text type="secondary">{dayjs(purchase.createdAt).format('MMM D, YYYY · HH:mm')}</Text>
        <OrderStatusTag status={purchase.status} />
      </Flex>
      <Title level={5} style={{ margin: 0 }}>
        {formatPoints(purchase.total)}
      </Title>
    </Flex>

    {purchase.rejectionReason ? (
      <Text type="danger" style={{ display: 'block', marginTop: 8, fontSize: 13 }}>
        Reason: {purchase.rejectionReason}
      </Text>
    ) : null}

    <Divider style={{ margin: '12px 0' }} />

    <Flex vertical gap={12}>
      {purchase.items.map((item) => (
        <Flex key={item.skuId} align="center" gap={12}>
          <div className={styles.thumb}>
            {item.imageUrl ? <img src={item.imageUrl} alt={item.title} /> : <span>No image</span>}
          </div>
          <Flex vertical flex={1} className={styles.info}>
            <Text strong ellipsis={{ tooltip: item.title }}>
              {item.title}
            </Text>
            <Text type="secondary">
              {item.quantity} × {formatPoints(item.unitPrice)}
            </Text>
          </Flex>
          <Text className={styles.lineTotal}>{formatPoints(item.lineTotal)}</Text>
        </Flex>
      ))}
    </Flex>
  </Card>
);
